import { useTranslation } from 'react-i18next';
import cls from './addNewUserModal.module.scss';
import { useState } from 'react';
import { RadioTwoBox } from '../radio-two-box';
import { Button } from '../button';

interface addNewUserModalInterface {
    onCancel: (boolean) => void;
    setModalType: (string) => void;
}

export const AddNewUserModal = ({ 
    onCancel,
    setModalType
}: addNewUserModalInterface) => {
    const { t } = useTranslation();
    const firstLabel = 'first';
    const [selectedOption, setSelectedOption] = useState<string>(firstLabel);
    
    return (
        <>
            <h3 className={cls.modalHeader}>
                {t('employeeManagement.addNewUserModal')}
            </h3>

            <RadioTwoBox 
                className={cls.modalDescription}
                labelFirst={t('employeeManagement.radioFirstDescription')}
                labelSecond={t('employeeManagement.radioSecondDescription')}
                name="customRadio"
                valueFirst="first"
                valueSecond="second"
                value={selectedOption}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSelectedOption(e.target.value)}
            />

            <p className={cls.modalDescription}>{selectedOption === 'first' ? t('employeeManagement.addNewUserModaldescriptionSingle'): t('employeeManagement.addNewUserModaldescriptionMultiple')}</p>
            <div className={cls.modalButtonWrapper}>
                <Button
                    className={cls.modalButton}
                    styleType="border"
                    type="button"
                    onClick={onCancel}
                >
                    {t('employeeManagement.cancel')}
                </Button>
                <Button className={cls.modalButton} onClick={() => {
                    setModalType(selectedOption === 'first' ? 'addNewUserSingle' : 'addNewUserMultiple');
                }}>
                    {t('employeeManagement.Next')}
                </Button>
            </div>
        </>
    );
};